import { MakeCall } from './createMakeCall';
import { ListingPhoto, ListingPhotoType } from './types/Listing';

export interface UpdateListingPhotoOptions {
  rotate?: number;
  rotateIncrement?: number;
  type?: ListingPhotoType;
}

const updateListingPhoto =
  (makeCall: MakeCall) =>
  (
    listingId: number,
    photoId: number,
    { rotate, rotateIncrement, type }: UpdateListingPhotoOptions,
  ) =>
    makeCall<ListingPhoto[]>(
      'PUT',
      `/api/v2/listing/${listingId}/photo/${photoId}`,
      {
        data: {
          rotate,
          rotateIncrement,
          type,
        },
      },
    );
export { updateListingPhoto };
